import type { IAuthService, LogoutResponse, TokenSessionResponse } from '../../types/serviceType';
import { LOGOUT_ROUTES, TOKEN_SESSION_ROUTES } from '../requestsService';

export class AuthService implements IAuthService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Performs user logout
   */
  async postLogout(): Promise<LogoutResponse> {
    return this.fetch<LogoutResponse>(LOGOUT_ROUTES.LOGOUT, {
      method: 'POST',
    });
  }

  /**
   * Validates active session from HTTP-only cookies.
   */
  async getTokenSession(): Promise<TokenSessionResponse> {
    return this.fetch<TokenSessionResponse>(TOKEN_SESSION_ROUTES.GET_TOKEN_SESSION, {
      method: 'GET',
    });
  }
}
